let isLiveAPI = false;


const liveBaseUrl = 'https://crendly-apim-prod.azure-api.net'
export const url = {
    IDENTITY_BASE_URL: isLiveAPI ? `${liveBaseUrl}/Identity-Service/api/Identity` : 'https://trustbreed.azurewebsites.net/api/Identity',
    AUTH_BASE_URL: isLiveAPI ? `${liveBaseUrl}/api/CrendlyAdmin` : 'https://trustbreed-auth-service.azurewebsites.net/api/CrendlyAdmin',
    PROFILE_BASE_URL: isLiveAPI ? `${liveBaseUrl}/Identity-Service/api/profilemanagement` : 'https://trustbreed.azurewebsites.net/api/profilemanagement',
    LOAN_BASE_URL: isLiveAPI ? `${liveBaseUrl}/creditservice/api/v1` : 'https://crendly-credit.azurewebsites.net/api/v1',
    LOAN_REPAYMENT_BASE_URL: isLiveAPI ? `${liveBaseUrl}/repayment-service/api/v1/LoanRepayment` : 'https://crendly-repayment-service.azurewebsites.net/api/v1/LoanRepayment',
    RECOMMENDATION_BASE_URL: isLiveAPI ? `${liveBaseUrl}/creditservice/api/Recommendation` : 'https://crendly-credit.azurewebsites.net/api/Recommendation',
    DECISION_BASE_URL: isLiveAPI ? `${liveBaseUrl}/CreditDecision/api` : 'https://crendly-decision.azurewebsites.net/api',
    WALLET_BASE_URL: isLiveAPI ? `${liveBaseUrl}/wallet/api` : 'https://crendly-wallet.azurewebsites.net/api',
    NOTIFICATION_URL: isLiveAPI ? `${liveBaseUrl}/notification-service/api` : 'https://trustbreed-notification-service.azurewebsites.net/api',
    MAIN_BASE_URL: 'https://crendly-apim.azure-api.net',
    RATING_URL: isLiveAPI ? `${liveBaseUrl}/api/ratings` : 'https://crendly-ratings-service.azurewebsites.net/api/ratings',
    CHARGES_URL: isLiveAPI ? `${liveBaseUrl}/charges/api/Charge` : 'https://crendly-charges.azurewebsites.net/api/Charge',
    SUPPORT_AUDIT_URL: isLiveAPI ? `${liveBaseUrl}/support/api` : 'https://support-audit-service.azurewebsites.net/api'
}

export const credentials = {
    API_REQUEST_SECRET_KEY: '0c3e4177bec7428c96265e8593df4e13',
}

export const initialState = {
   
}

export const appSettings = {
    BACKGROUND_JOB_WAIT_TIME: 3 * 1000,
    TOKEN_REFRESH_TIME: 1000 * 60 * 8
}